/**
 * Links do site com a origem de cada botão (`?origem=hero`, `?origem=precos-estudio`).
 * A origem chega no cadastro e na análise de uso (plano 3.0, seção 9), para
 * saber qual botão traz gente de verdade.
 */
export const SIGNUP_PATH = '/auth/register';

export function signupQuery(origin: string): { origem: string } {
	return { origem: origin };
}
